// Sentry
import * as Sentry from '@sentry/vue';
import initializeRouter from '@/router';
import type { App } from 'vue';
import { vueIntegration } from '@sentry/vue';

export const sentry = (app: App) => {
  console.log('installing sentry plugin');

  if (import.meta.env.VITE_SENTRY_ENABLED === 'true') {
    console.log('Sentry is enabled');
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration({
          router: initializeRouter(),
          shouldCreateSpanForRequest: (url) => !url.match(/\/count_unread$/)
        }),
        vueIntegration({
          tracingOptions: {
            trackComponents: true
          }
        })
      ],
      tracePropagationTargets: [
        // deep-a api
        // /https:\/\/deep-llm-proxy.(?:[a-z]+\.)?deepcloud\.swiss\/api/,
        // deep-admin api
        /https:\/\/(?:[a-z]+\.)?deepcloud\.swiss\/api/,
        // deep-box api
        /https:\/\/api(?:\.[a-z]+)?\.deepbox\.swiss\/api/,
        // deep-sign api
        /https:\/\/api(?:\.[a-z]+)?\.sign.deepbox\.swiss\/api/,
        // deep-onboarding api
        /https:\/\/(?:[a-z]+\.)?deepcloud\.swiss\/api-internal/
      ],
      environment: import.meta.env.VITE_ENVIRONMENT || 'dev',
      release: import.meta.env.VITE_SENTRY_RELEASE,
      debug: import.meta.env.VITE_SENTRY_DEBUG === 'true',
      tracesSampleRate: parseFloat(
        import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE
      ),
      ignoreErrors: [
        'Request failed with status code',
        'Request aborted',
        'Network Error',
        'FILE_NOT_FOUND',
        'KC_ERROR_UPDATE_TOKEN' // from use-keycloak
      ]
    });
  }
};

export default sentry;
